"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRegionEntity = void 0;
const CSSharedEntity_1 = require("../entity/CSSharedEntity");
class CSRegionEntity extends CSSharedEntity_1.CSSharedEntity {
}
exports.CSRegionEntity = CSRegionEntity;
//# sourceMappingURL=CSRegionEntity.js.map